import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=19f19da3&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=19f19da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f19da3",
  null
  
)

export default component.exports